<section>
  <app-wizard-steps
    [steps]="steps"
    (stepChangeIndex)="stepChangeIndex.emit($event)"
    [currentStepIndex]="currentStepIndex"
    [allowNavigation]="allowNavigation"
  ></app-wizard-steps>
  <ng-content></ng-content>
</section>
